
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDamperHorizontalOnLarge as ObiDamperHorizontalOnLargeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-damper-horizontal-on-large.js';
 
 
 

 
 export const ObiDamperHorizontalOnLarge = createComponent({
   react: React,
   tagName: 'obi-damper-horizontal-on-large',
   elementClass: ObiDamperHorizontalOnLargeElement,
   events: {
     
   }
  });
 
 